import mixins from 'vue-typed-mixins'

import Phq9 from '@/survey/measures/phq9/Phq9.vue'
import PatientLetter from '@/views/treatment/depression/PatientLetter.vue'
import TherapistLetter from '@/views/treatment/depression/TherapistLetter.vue'
import TreatmentMixin from '@/views/treatment/TreatmentMixin.ts'
import Await from './Await.vue'

// cbt exercise widgets
import Activity from './cbt/activities-diary/Activity.vue'
import Reframing from './cbt/reframings-diary/Reframing.vue'
import Thought from './cbt/thoughts-diary/Thought.vue'

// ipt exercise widgets
import Conflict from './ipt/conflicts-diary/Conflict.vue'
import Relationship from './ipt/relationships-diary/Relationship.vue'
import Situation from './ipt/strategies-diary/Situation.vue'

export default mixins(TreatmentMixin).extend({
  components: {
    ActivitiesDiary: () => import('./cbt/activities-diary/DiaryEditor.vue'),
    Activity,
    Await,
    Conflict,
    ConflictsDiary: () => import('./ipt/conflicts-diary/DiaryEditor.vue'),
    PatientLetter,
    Phq9,
    Reframing,
    ReframingsDiary: () => import('./cbt/reframings-diary/DiaryEditor.vue'),
    Relationship,
    RelationshipsDiary: () => import('./ipt/relationships-diary/DiaryEditor.vue'),
    Situation,
    StrategiesDiary: () => import('./ipt/strategies-diary/DiaryEditor.vue'),
    TherapistLetter,
    Thought,
    ThoughtsDiary: () => import('./cbt/thoughts-diary/DiaryEditor.vue'),
  },
})
